import { render, staticRenderFns } from "./FoulingDetailsPanel.vue?vue&type=template&id=63a096f6&scoped=true&"
import script from "./FoulingDetailsPanel.vue?vue&type=script&lang=js&"
export * from "./FoulingDetailsPanel.vue?vue&type=script&lang=js&"
import style0 from "./FoulingDetailsPanel.vue?vue&type=style&index=0&id=63a096f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a096f6",
  null
  
)

export default component.exports